'use strict';

export const tab = (() => {
    const tabSwitch = event => {
        const $this = $(event.currentTarget);

        $this.closest('.js-tab-content').find('.js-tab-board').removeClass('is-active');
        $this.parent('.tab-content__ttl').parent('.js-tab-board').addClass('is-active');
    };

    const init = () => {
        $('.js-tab').on('click', event => {
            tabSwitch(event);
        });
    };

    return {
        init: init
    };
})();
